export const en = {
    'minus-keywords-illegal-minus-keyword-chars':
        'Only English, Turkish, Kazakh, Russian, Ukrainian, or Belarusian letters, inverted commas, square brackets, the characters "-", "+", "!", and spaces are allowed in negative keywords. Errors in keywords: {minusWords}',
    'minus-keywords-imbalanced-square-brackets':
        'Invalid square brackets "[" "]" in the negative keywords: {minusWords}',
    'minus-keywords-invalid-dot':
        'Negative keywords can contain no more than two consecutive digits separated by a dot. Errors in keywords: {minusWords}',
    'minus-keywords-invalid-exclamation-mark': 'Invalid exclamation mark "!" in the negative keywords: {minusWords}',
    'minus-keywords-invalid-minus-mark':
        'Invalid "-" in the negative keywords: {minusWords}. The "- " character cannot be used at the beginning or end of keywords',
    'minus-keywords-invalid-operators-inside-square-brackets':
        'You cannot use the characters +-"" within square brackets [], negative keywords: {minusWords}',
    'minus-keywords-invalid-plus-mark': 'Invalid "+" in the negative keywords: {minusWords}',
    'minus-keywords-invalid-word-first-character':
        'Negative keywords contain an invalid combination of special characters.',
    'minus-keywords-max-count-words-in-keyword':
        'A negative keyword cannot contain more than {maxWords} keywords: {minusWords}',
    'minus-keywords-max-length':
        'The negative keyword exceeds the maximum keyword length of {maxLength} characters. Errors in keywords: {word}',
    'minus-keywords-max-length-minus-keywords':
        'Exceeded the limit of {maxLength} characters in negative keywords per ad group',
    'minus-keywords-nested-or-empty-square-brackets':
        'Square brackets "[" "]" cannot be empty and nested, the negative keywords: {minusWords}',
    'minus-keywords-null': 'Negative keywords shared in ad group cannot contain empty values',
    'minus-keywords-separate-dot': 'Negative keywords cannot contain stand-alone dots: {minusWords}',
    'minus-keywords-wrong-quote': 'Invalid inverted commas in negative keywords: {minusWords}',
    'minus-phrase-binding-many-phrases-list-error': {
        one: 'Unable to link sets to the selected ad group',
        some: 'Unable to link sets to the selected ad groups',
        many: 'Unable to link sets to the selected ad groups',
        none: ''
    },
    'minus-phrase-binding-many-phrases-list-error-many': 'Unable to link sets to the selected ad groups',
    'minus-phrase-binding-many-phrases-list-error-one': 'Unable to link sets to the selected ad group',
    'minus-phrase-binding-many-phrases-list-success': {
        one: 'Sets linked to the selected ad group',
        some: 'Sets linked to the selected ad groups',
        many: 'Sets linked to the selected ad groups',
        none: ''
    },
    'minus-phrase-binding-many-phrases-list-success-many': 'Sets linked to the selected ad groups',
    'minus-phrase-binding-many-phrases-list-success-one': 'Sets linked to the selected ad group',
    'minus-phrase-binding-many-phrases-list-warning': {
        one: 'Sets linked to {count} our of {total} ad groups. Unable to link to the others ',
        some: 'Sets linked to {count} out of {total} ad groups. Unable to link to the others ',
        many: 'Sets linked to {count} out of {total} ad groups. Unable to link to the others ',
        none: ''
    },
    'minus-phrase-binding-one-phrases-list-error': {
        one: 'Unable to link the set to the selected ad group',
        some: 'Unable to link the set to the selected ad groups',
        many: 'Unable to link the set to the selected ad groups',
        none: ''
    },
    'minus-phrase-binding-one-phrases-list-error-many': 'Unable to link the set to the selected ad groups',
    'minus-phrase-binding-one-phrases-list-error-one': 'Unable to link the set to the selected ad group',
    'minus-phrase-binding-one-phrases-list-success': {
        one: 'The set is linked to the selected ad group',
        some: 'The set is linked to the selected ad groups',
        many: 'The set is linked to the selected ad groups',
        none: ''
    },
    'minus-phrase-binding-one-phrases-list-success-many': 'The set is linked to the selected ad groups',
    'minus-phrase-binding-one-phrases-list-success-one': 'The set is linked to the selected ad group',
    'minus-phrase-binding-one-phrases-list-warning': {
        one: 'The set is linked to {count} out of {total} ad groups. Unable to link to the others',
        some: 'The set is linked to {count} out of {total} ad groups. Unable to link to the others',
        many: 'The set is linked to {count} out of {total} ad groups. Unable to link to the others',
        none: ''
    },
    'minus-phrase-unbinding-many-phrases-list-error': {
        one: 'Unable to unlink sets from the selected ad group',
        some: 'Unable to unlink sets from the selected ad groups',
        many: 'Unable to unlink sets from the selected ad groups',
        none: ''
    },
    'minus-phrase-unbinding-many-phrases-list-error-many': 'Unable to unlink sets from the selected ad groups',
    'minus-phrase-unbinding-many-phrases-list-error-one': 'Unable to unlink sets from the selected ad group',
    'minus-phrase-unbinding-many-phrases-list-success': {
        one: 'Sets unlinked from the selected ad group',
        some: 'Sets unlinked from the selected ad groups',
        many: 'Sets unlinked from the selected ad groups',
        none: ''
    },
    'minus-phrase-unbinding-many-phrases-list-success-many': 'Sets unlinked from the selected ad groups',
    'minus-phrase-unbinding-many-phrases-list-success-one': 'Sets unlinked from the selected ad group',
    'minus-phrase-unbinding-many-phrases-list-warning': {
        one: 'Sets unlinked from {count} out of {total} ad groups. Unable to unlink from the others ',
        some: 'Sets unlinked from {count} out of {total} ad groups. Unable to unlink from the others ',
        many: 'Sets unlinked from {count} out of {total} ad groups. Unable to unlink from the others ',
        none: ''
    },
    'minus-phrase-unbinding-one-phrases-list-error': {
        one: 'Unable to unlink the set from the selected ad group',
        some: 'Unable to unlink the set from the selected ad groups',
        many: 'Unable to unlink the set from the selected ad groups',
        none: ''
    },
    'minus-phrase-unbinding-one-phrases-list-error-many': 'Unable to unlink the set from the selected ad groups',
    'minus-phrase-unbinding-one-phrases-list-error-one': 'Unable to unlink the set from the selected ad group',
    'minus-phrase-unbinding-one-phrases-list-success': {
        one: 'The set is unlinked from the selected ad group',
        some: 'The set is unlinked from the selected ad groups',
        many: 'The set is unlinked from the selected ad groups',
        none: ''
    },
    'minus-phrase-unbinding-one-phrases-list-success-many': 'The set is unlinked from the selected ad groups',
    'minus-phrase-unbinding-one-phrases-list-success-one': 'The set is unlinked from the selected ad group',
    'minus-phrase-unbinding-one-phrases-list-warning': {
        one: 'The set is unlinked from {count} out of {total} ad groups. Unable to unlink from the others ',
        some: 'The set is unlinked from {count} out of {total} ad groups. Unable to unlink from the others ',
        many: 'The set is unlinked from {count} out of {total} ad groups. Unable to unlink from the others ',
        none: ''
    }
};
